var locale = {
    placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/time-picker/locale/en_US.js
// module id = 168
// module chunks = 0